import { recordGoogleLoginEvent } from "../services/authApi";

const LOGIN_HISTORY_KEY = "captionPublishingLoginHistory";
const MAX_LOCAL_ENTRIES = 200;

const safeParse = (value) => {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const buildLoginEvent = (user, options = {}) => ({
  loginId: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  loggedInAt: new Date().toISOString(),
  email: user?.email || "",
  name: user?.name || "",
  googleId: user?.googleId || "",
  pictureUrl: user?.pictureUrl || "",
  page: options.page || (typeof window !== "undefined" ? window.location.pathname : "/captionPublishing"),
  userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
  loginMethod: "google",
  success: options.success !== false,
});

export const getLocalLoginHistory = () => {
  if (typeof window === "undefined") {
    return [];
  }

  return safeParse(localStorage.getItem(LOGIN_HISTORY_KEY));
};

export const appendLocalLoginEvent = (event) => {
  if (typeof window === "undefined" || !event) {
    return event;
  }

  const existing = getLocalLoginHistory();
  const next = [event, ...existing].slice(0, MAX_LOCAL_ENTRIES);
  localStorage.setItem(LOGIN_HISTORY_KEY, JSON.stringify(next));
  window.dispatchEvent(new Event("login-history-changed"));

  return event;
};

export const getLocalLoginHistoryForUser = (email) => {
  if (!email) {
    return getLocalLoginHistory();
  }

  return getLocalLoginHistory().filter(
    (entry) => String(entry.email || "").toLowerCase() === String(email).toLowerCase(),
  );
};

export const recordGoogleLogin = async (user, options = {}) => {
  const event = buildLoginEvent(user, options);
  appendLocalLoginEvent(event);

  try {
    await recordGoogleLoginEvent(event);
  } catch {
    // Keep local history even when API logging is not deployed yet.
  }

  return event;
};
